import React from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";

export default function ChangeIcon(props) {
  return (
    <SvgIcon
      color={props.color}
      viewBox="0 -4 24 24"
      style={{ fontSize: "24px" }}
    >
      <path d="M4.66 7.33333L2 10L4.66 12.6667V10.6667H9.33333V9.33333H4.66V7.33333ZM14 5.99999L11.34 3.33333V5.33333H6.66667V6.66666H11.34V8.66666L14 5.99999Z" />
    </SvgIcon>
  );
}

ChangeIcon.propTypes = {
  color: PropTypes.string
};
